// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.document.CreatePatientDocumentRequest */
/* istanbul ignore next */
@GandalfModel
export class CreatePatientDocumentRequest extends GandalfModelBase {

	@GandalfLabel('Encounter')
	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfLabel('Recipient')
	@GandalfValidator({ notNull: { message: 'Recipient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	recipientId!: number;

	@GandalfConstantDecorator(constants.PatientDocumentRecipientType)
	@GandalfLabel('Recipient Type')
	@GandalfValidator({ notNull: { message: 'Recipient Type is required' } })
	@GandalfProperty({ designType: constants.PatientDocumentRecipientType, isRequired: true })
	recipientType!: constants.PatientDocumentRecipientType;

	@GandalfLabel('Save To Folder')
	@GandalfValidator({ notNull: { message: 'Save To Folder is required' } })
	@GandalfValidator({ sizeString: { message: 'Save To Folder must be between 1 and 50 characters', minLength: 1, maxLength: 50 } })
	@GandalfProperty({ designType: String, isRequired: true })
	saveToFolder!: string;

	@GandalfLabel('Template')
	@GandalfValidator({ notNull: { message: 'Template is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	templateId!: number;

}
